<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-ftyInvOutbound',
  components: { PageTable },
}
</script>
